<template>
    <GastouderMutationOverview
        :idGastouderPeriod="idGastouderPeriod"
        :idChild="idChild"
        :canEdit="true"
        :idStepper="1"
        :currentDate="date"
    >
        <template v-slot:bottomButtons>
            <div class="row mb-3 justify-content-end">
                <div class="col-auto">
                    <router-link
                        class="btn btn-info"
                        type="button"
                        :to="'/gastouder/hours-open/check/' + idGastouderPeriod + '/' + idChild"
                    >
                        Controleren
                    </router-link>
                </div>
            </div>
        </template>
    </GastouderMutationOverview>
</template>

<script>
import GastouderMutationOverview from "@/views/gastouder/components/GastouderMutationOverview";

export default {
    name: 'GastouderHoursInsert',
    props:  [
        'idGastouderPeriod',
        'idChild',
        'date'
    ],
    components: {
        GastouderMutationOverview,
    }
}

</script>